import styled, { keyframes } from 'styled-components';
import * as PopoverPrimitive from '@radix-ui/react-popover';
import { breakpoints } from '../../style';
import { ContentProps } from './popover';

const slideUpAndFade = keyframes`
  0% {
    opacity: 0;
    transform: translateY(2px);
  }


  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideRightAndFade = keyframes`
  0% {
    opacity: 0;
    transform: translateX(-2px);
  }


  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

const slideDownAndFade = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-2px);
  }


  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const slideLeftAndFade = keyframes`
  0% {
    opacity: 0;
    transform: translateX(2px);
  }


  100% {
    opacity: 1;
    transform: translateX(0);
  }
`;

/**
 * This component is a wrapper of the radix popover primitive + animation that we add
 */
const AnimatedPopoverContent = styled(PopoverPrimitive.Content).attrs(({ side }) => ({
  side: window.innerWidth >= breakpoints.sm ? side : 'bottom',
}))<ContentProps>`
  @media (prefers-reduced-motion: no-preference) {
    animation-duration: 400ms;
    animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
    will-change: transform, opacity;
    &[data-state='open'] {
      &[data-side='top'] {
        animation-name: ${slideDownAndFade};
      }

      &[data-side='right'] {
        animation-name: ${slideLeftAndFade};
      }

      &[data-side='bottom'] {
        animation-name: ${slideUpAndFade};
      }

      &[data-side='left'] {
        animation-name: ${slideRightAndFade};
      }
    }
  }
`;

export default AnimatedPopoverContent;
